import { render, staticRenderFns } from "./ultimateGear.vue?vue&type=template&id=65b1d8d1&scoped=true&"
import script from "./ultimateGear.vue?vue&type=script&lang=js&"
export * from "./ultimateGear.vue?vue&type=script&lang=js&"
import style0 from "./ultimateGear.vue?vue&type=style&index=0&id=65b1d8d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1d8d1",
  null
  
)

export default component.exports